import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { runCommand as run } from '@wix/package-manager';

export const skillsAddCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  // The `skills` CLI uses -y/--yes to skip prompts.
  const args = ['--yes', 'skills', 'add', 'wix/skills', '-y'] as const;

  /**
   * Test-only escape hatch:
   * The CLI driver runs the CLI through `fnm exec`, which can rewrite PATH.
   * In tests we want deterministic interception of `npx` without relying on PATH
   * ordering, so we allow overriding the executable via env var.
   */
  const npxExecutable = process.env.WIX_CLI_NPX_PATH ?? 'npx';

  return createCommand('add')
    .description('Add Wix skills to your project')
    .action(async (_, command) => {
      const { runCommand } = await import('./render-command.js');

      await runCommand(command, services, cliVersion, async (model) => {
        try {
          await run(`${npxExecutable} ${args.join(' ')}`, {
            cwd: model.projectFolder,
            output: process.stdout,
          });
        } catch (e) {
          throw new CliError({
            code: CliErrorCode.FailedToRunExternalCommand({
              file: 'npx',
              args: [...args],
            }),
            cause: e,
          });
        }
      });
    });
};
